/** Estados de producto en inventario (valores que envía/recibe el API). */
export type InventoryStatus =
  | 'Activo'
  | 'Vendido'
  | 'Inactivo'
  | 'Incompleto'
  | 'Devuelto'
  | 'Devolución pendiente'
  /** Filtro de listado: inventario pendiente de recogida por consignador desactivado. */
  | 'Recogida pendiente';

export const INVENTORY_STATUS_OPTIONS: InventoryStatus[] = [
  'Activo',
  'Vendido',
  'Inactivo',
  'Incompleto',
  'Devuelto',
  'Devolución pendiente',
  'Recogida pendiente',
];

/** Campos permitidos para `orderBy` en GET /api/admin/inventory */
export type AdminInventoryOrderBy = 'id' | 'title' | 'cost' | 'price' | 'size';

export type AdminInventoryOrderDirection = 'asc' | 'desc';

export const DEFAULT_ADMIN_INVENTORY_ORDER_BY: AdminInventoryOrderBy = 'id';

export const DEFAULT_ADMIN_INVENTORY_ORDER_DIRECTION: AdminInventoryOrderDirection = 'desc';

export interface AdminInventoryRow {
  id: number;
  /** Identificador Urban Utility (UU ID). */
  artId: string | null;
  handle: string | null;
  title: string;
  imageUrl: string | null;
  category: string | null;
  sku: string | null;
  consignorId: number;
  consignorName: string;
  /** Talla en centímetros (p. ej. "27.5" o "42") — el API envía CM. */
  sizeCm: string | null;
  condition: string;
  /** Costo / pago al consignador */
  cost: number;
  /** Precio de venta */
  price: number;
  status: InventoryStatus;
  shopifyActive: boolean;
}

export interface AdminInventorySummary {
  totalCost: number;
  totalPrice: number;
  /** Productos en estado Activo (el API puede seguir enviando la clave `availableCount`). */
  availableCount: number;
  totalCount: number;
}

export interface AdminInventoryListPayload {
  items: AdminInventoryRow[];
  total: number;
  page: number;
  pageSize: number;
  summary?: AdminInventorySummary;
}
